window.addEventListener('DOMContentLoaded', () => {

    // -----------------Visual Size Guide window triggers
    visualSizeGuideTriggers();

    function visualSizeGuideTriggers(){
        let visualSizeGuideWindow = document.getElementById("visual-size-guide-window");

        document.addEventListener('click',function(eventClicked){
            const target = eventClicked.target;
            const parent = target && target.parentElement;

            if(target && target.getAttribute && target.getAttribute("vsg-trigger") == "open"){
                openWindow();
            }
            if(parent && parent.getAttribute("vsg-trigger") == "open"){
                openWindow();
            }

            if(target && target.getAttribute && target.getAttribute("vsg-trigger") == "close"){
                closeWindow();
            }
            if(parent && parent.getAttribute("vsg-trigger") == "close"){
                closeWindow();
            }
        });

        function openWindow(){
            visualSizeGuideWindow.style.visibility = "visible";
            visualSizeGuideWindow.style.opacity = "1";
            document.body.classList.add("on-modal-stop-scroll");
        }

        function closeWindow(){
            visualSizeGuideWindow.style.visibility = "hidden";
            visualSizeGuideWindow.style.opacity = "0";
            document.body.classList.remove("on-modal-stop-scroll");
        }
    }

    // ------------------Visual Size Guide Component's functions
	visualSizeGuide();

	// Initialize Visual Size Guide
	function visualSizeGuide(){
		let guideClothingOption = document.getElementsByClassName("vsg-clothing-options");
		let visualGuideOptionOne = document.getElementsByClassName("visual-guide-option-1");
		let visualGuideOptionTwo = document.getElementsByClassName("visual-guide-option-2");

		let visualGuideSizeOption = document.getElementsByClassName("vsg-size-option");
		let visualGuideVideoOption = document.getElementsByClassName("vsg-video-size-option");
		let visualGuideDescs = document.getElementsByClassName("vsg-desc-option");

		let visualGuideSizeOptionCheeky = document.getElementsByClassName("vsg-size-option-cheeky");
		let visualGuideVideoOptionCheeky = document.getElementsByClassName("vsg-video-size-option-cheeky");
		let visualGuideDescsCheeky = document.getElementsByClassName("vsg-desc-option-cheeky");

		let vidPlayIcon = document.getElementsByClassName("vsg-video-trigger-icon");
		let videoItems = document.getElementsByClassName("vsg-playback");

		if (!guideClothingOption){
			return;
		}
		if (!visualGuideOptionOne){
			return;
		}
		if (!visualGuideOptionTwo){
			return;
		}
		if (!visualGuideSizeOption){
			return;
		}
		if (!visualGuideVideoOption){
			return;
		}
		if (!visualGuideDescs){
			return;
		}
		if (!visualGuideSizeOptionCheeky){
			return;
		}
		if (!visualGuideVideoOptionCheeky){
			return;
		}
		if (!visualGuideDescsCheeky){
			return;
		}
		if (!vidPlayIcon){
			return;
		}
		if (!videoItems){
			return;
		}

		// ----------loop clothing option buttons
		for (let i=0; i<guideClothingOption.length; i++){
			guideClothingOption[i].addEventListener('click', function(eventClick){
				visualSizeGuideMainTrigger(eventClick);
			});
		}

		// ----------Trigger clothing option selection
		function visualSizeGuideMainTrigger(eventClick){

			for (let j=0; j<guideClothingOption.length; j++){

				if (eventClick.target.parentNode.hasAttribute("visual-guide-option-toggle")){
					let targetAttr = eventClick.target.parentNode.getAttribute("visual-guide-option-toggle");

					if (targetAttr == guideClothingOption[j].getAttribute("visual-guide-option-toggle")){
						guideClothingOption[j].classList.add("vsg-clothing-option-active");
						// loop the div wrappers
						for (let loopOne=0; loopOne<visualGuideOptionOne.length; loopOne++){
							for (let loopTwo=0; loopTwo<visualGuideOptionTwo.length; loopTwo++){
								// show the correct div
								if (guideClothingOption[j].getAttribute("visual-guide-option-toggle") == 1 ){
									visualGuideOptionOne[loopOne].style.display = "block";
									visualGuideOptionTwo[loopTwo].style.display = "none";
								}
								else{
									visualGuideOptionOne[loopOne].style.display = "none";
									visualGuideOptionTwo[loopTwo].style.display = "block";
								}
							}
						}
					}
					else{
						guideClothingOption[j].classList.remove("vsg-clothing-option-active");
					}
				}
			}
		}

		// -----------Normal loop size options
		for (let k=0; k<visualGuideSizeOption.length; k++){
			visualGuideSizeOption[k].addEventListener('click', function(eventClicks){
				visualSizeGuideSizesTrigger(eventClicks);
			});
		}

		// ------------Normal Trigger size options with their videos and descriptions
		function visualSizeGuideSizesTrigger(eventClicks){
			for (let l=0; l<visualGuideSizeOption.length; l++){

				if (eventClicks.target.hasAttribute("visual-guide-size")){
					let targetAttrSize = eventClicks.target.getAttribute("visual-guide-size");

					if (targetAttrSize == visualGuideSizeOption[l].getAttribute("visual-guide-size")){
						visualGuideSizeOption[l].classList.add("vsg-guide-size-active");
						// loop all video placeholders
						for (let loopOpt=0; loopOpt<visualGuideVideoOption.length; loopOpt++){
							// find if the current targeted/active size matches the video
							if (visualGuideSizeOption[l].getAttribute("visual-guide-size") == visualGuideVideoOption[loopOpt].getAttribute("visual-guide-size")){
								visualGuideVideoOption[loopOpt].classList.add("vsg-video-size-option-active");
							} 
							else{
								visualGuideVideoOption[loopOpt].classList.remove("vsg-video-size-option-active");
							}
						}
						// loop all product descriptions
						for (let loopDesc=0; loopDesc<visualGuideDescs.length; loopDesc++){
							// find if the current targeted/active size matches the desc
							if (visualGuideSizeOption[l].getAttribute("visual-guide-size") == visualGuideDescs[loopDesc].getAttribute("visual-guide-size")){
								visualGuideDescs[loopDesc].classList.add("vsg-desc-option-active");
							}
							else{
								visualGuideDescs[loopDesc].classList.remove("vsg-desc-option-active");
							}
						}
					}
					else{
						visualGuideSizeOption[l].classList.remove("vsg-guide-size-active");
					}
				}
			}
		}

		// -----------Cheeky loop size options
		for (let n=0; n<visualGuideSizeOptionCheeky.length; n++){
			visualGuideSizeOptionCheeky[n].addEventListener('click', function(eventClicked){
				visualSizeGuideSizesTriggerCheeky(eventClicked);
			});
		}

		// ------------Cheeky Trigger size options with their videos and descriptions
		function visualSizeGuideSizesTriggerCheeky(eventClicked){
			for (let l=0; l<visualGuideSizeOptionCheeky.length; l++){

				if (eventClicked.target.hasAttribute("visual-guide-size")){
					let targetAttrSize = eventClicked.target.getAttribute("visual-guide-size");

					if (targetAttrSize == visualGuideSizeOptionCheeky[l].getAttribute("visual-guide-size")){
						visualGuideSizeOptionCheeky[l].classList.add("vsg-guide-size-active");
						// loop all video placeholders
						for (let loopOpt=0; loopOpt<visualGuideVideoOptionCheeky.length; loopOpt++){
							// find if the current targeted/active size matches the video
							if (visualGuideSizeOptionCheeky[l].getAttribute("visual-guide-size") == visualGuideVideoOptionCheeky[loopOpt].getAttribute("visual-guide-size")){
								visualGuideVideoOptionCheeky[loopOpt].classList.add("vsg-video-size-option-active");
							}
							else{
								visualGuideVideoOptionCheeky[loopOpt].classList.remove("vsg-video-size-option-active");
							}
						}
						// loop all product descriptions
						for (let loopDesc=0; loopDesc<visualGuideDescsCheeky.length; loopDesc++){
							// find if the current targeted/active size matches the desc
							if (visualGuideSizeOptionCheeky[l].getAttribute("visual-guide-size") == visualGuideDescsCheeky[loopDesc].getAttribute("visual-guide-size")){
								visualGuideDescsCheeky[loopDesc].classList.add("vsg-desc-option-active");
							}
							else{
								visualGuideDescsCheeky[loopDesc].classList.remove("vsg-desc-option-active");
							}
						}
					}
					else{
						visualGuideSizeOptionCheeky[l].classList.remove("vsg-guide-size-active");
					}
				}
			}
		}


		//------------Visual Size Guide Custom video player
		vsgVideoTrigger();

		function vsgVideoTrigger(){

			for (let i=0; i<vidPlayIcon.length; i++){
				vidPlayIcon[i].addEventListener('click', function(vClick){
					vsgVideoCommands(vClick);
				});
			}
		
			function vsgVideoCommands(vClick){ 
				for (let j=0; j<videoItems.length; j++){
					// if video normal style
					if (vClick.target.parentNode.hasAttribute("nm-playback")){
						let targetAttrSize = vClick.target.parentNode.getAttribute("nm-playback");

								if ((targetAttrSize == videoItems[j].getAttribute("nm-playback"))){
									// If video is not paused
									if((!videoItems[j].paused)){
										videoItems[j].pause(); 
										vidPlayIcon[j].style.opacity = "1";
										vidPlayIcon[j].style.transition = "0.3s ease-in-out";
									}
									else{
										videoItems[j].play(); 
										vidPlayIcon[j].style.opacity = "0";
										vidPlayIcon[j].style.transition = "0.3s ease-in-out";
									}
								}
					}
					// if video cheeky style
					if (vClick.target.parentNode.hasAttribute("ch-playback")){
						let targetAttrSize = vClick.target.parentNode.getAttribute("ch-playback");

								if ((targetAttrSize == videoItems[j].getAttribute("ch-playback"))){
									// If video is not paused
									if((!videoItems[j].paused)){
										videoItems[j].pause(); 
										vidPlayIcon[j].style.opacity = "1";
										vidPlayIcon[j].style.transition = "0.3s ease-in-out";
									}
									else{
										videoItems[j].play(); 
										vidPlayIcon[j].style.opacity = "0";
										vidPlayIcon[j].style.transition = "0.3s ease-in-out";
									}
								}
					}

					// Check if video finished on its own
					videoItems[j].addEventListener('ended',vsgVideoEnded,false);

					function vsgVideoEnded() {
						vidPlayIcon[j].style.opacity = "1";
					}
				
				}
			} 

		}
		//------------Visual Size Guide Custom video player END

	}
	// ------------------Visual Size Guide Component's functions END
});